<template>
    <div class="container-fluid">
        <nav class="row d-flex px-3">
            <div class="col-lg-6 col-xs-10">
                <div class="pb-0 display-4"><h3>{{tr(pageTitle)}}</h3></div>
            </div>
            <div class="col-lg-6 col-xs-12 ">
                <breadcrumb
                    :list="[{title: module}, {title: pageTitle}]"
                ></breadcrumb>
            </div>
        </nav>
        <abm-error-signature
            v-if="user && ready"
            :refresh="true"
            :endpoint="apiEndpoint"
            :options="options"
            :tableName="tableName"
        ></abm-error-signature>
    </div>
</template>

<script>
import abmTable from '@/components/pages/AbmTable';
const abmErrorSignature = importVueComp('components/tools', 'abmErrorSignature')
import { mapState } from 'vuex';

export default {
    name: 'page-error-signature',
    props: ['byUser', 'title', 'status', 'table'],
    mixins: [abmTable],
    components: {
        'abm-error-signature': abmErrorSignature,
    },
    computed: {
        ...mapState({
            user: state => state.main.user,
        }),
        pageTitle () {
            if (this.title) return this.title;
            if (this.options.title) return this.options.title;
            return this.tableName;
        }
    },
    methods: {
        async onMount () {
            this.apiEndpoint = `/api/errorsignature/?`;
            if (this.title) this.options.title = this.title;
            this.module = frontTools.getModuleByPath(this.$router.currentRoute.path.split('/')[2]);
            this.tableName = this.table? this.table: 'errorsignature';
            this.ready = true;

        },
    }
}
</script>

